import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ImportDataService = {
  getTemplate: async () => {
    const response = await apiService.get("/productimport/download-template", {
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiService.post("/productimport/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
};

export default ImportDataService;
